import { render } from "./Goods.vue?vue&type=template&id=3bb4fa3c&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"

import "./Goods.vue?vue&type=style&index=0&id=3bb4fa3c&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/pro-base3-fe-portal-old1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb4fa3c"]])

export default __exports__